// extracted by mini-css-extract-plugin
export var dropdownButton = "_3e-0";
export var fullWidthDropdownButton = "_3e-1";
export var icon = "_3e-3";
export var iconPlaceholder = "_3e-2";
export var menuItemRow = "_3e-9";
export var separator = "_3e-e";
export var shortcutContainer = "_3e-7";
export var shortcutContainerFilled = "_3e-8";
export var shortcutIconLg = "_3e-6";
export var shortcutIconMd = "_3e-5";
export var shortcutIconSm = "_3e-4";
export var submenuChevron = "_3e-d";
export var submenuDropdown = "_3e-a";
export var submenuTriggerRow = "_3e-b";
export var submenuTriggerRowOpen = "_3e-c";